import React from "react";
import { Link } from "react-router-dom";
import { SITE, whatsappLink } from "@/lib/site";
import { MessageCircle, ArrowUpRight } from "lucide-react";
import { locations } from "@/data/locations";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/5 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <div className="flex items-center">
              <img
                src={SITE.logoUrl}
                alt="Corrective Motion"
                loading="lazy"
                decoding="async"
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="mt-5 text-zinc-400 max-w-md leading-relaxed">
              Evidence-based corrective movement and performance training in Dubai.
              Founded by {SITE.founder}, Elite Master Trainer with 10+ years coaching premium clients.
            </p>
            <div className="mt-7 flex gap-3">
              <a
                href={whatsappLink()}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="inline-flex items-center gap-2 bg-gradient-to-r from-[#0055FF] to-[#00E5FF] text-black px-5 py-2.5 rounded-full text-sm font-semibold"
              >
                <MessageCircle className="w-4 h-4" /> Chat on WhatsApp
              </a>
              <a
                href={SITE.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-instagram"
                className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full text-sm font-semibold text-white border border-white/15 hover:border-[#00E5FF]/50 transition-colors"
              >
                Instagram
              </a>
            </div>
          </div>

          <div className="lg:col-span-4 lg:col-start-9">
            <div className="space-y-2 text-sm text-zinc-300">
              <div className="flex items-start gap-2">
                <span className="text-zinc-500">WhatsApp:</span>
                <a
                  href={whatsappLink()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-[#00E5FF]"
                >
                  {SITE.whatsappDisplay}
                </a>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-zinc-500">Instagram:</span>
                <a
                  href={SITE.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-white hover:text-[#00E5FF]"
                >
                  @{SITE.instagram}
                </a>
              </div>
              <div className="flex items-start gap-2">
                <span className="text-zinc-500">Train at:</span>
                <span className="text-white">Train Strength &amp; Fitness · Dubai Mall · Zabeel</span>
              </div>
            </div>

            <Link
              to="/#consult"
              data-testid="footer-cta"
              className="mt-7 inline-flex items-center gap-2 text-sm font-semibold text-white border-b border-[#00E5FF]/40 pb-1 hover:text-[#00E5FF] transition-colors"
            >
              Request a consultation
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-zinc-500">
          <div>© {new Date().getFullYear()} Corrective Motion · {SITE.founder}. All rights reserved.</div>
          <div className="flex items-center gap-2">
            <span className="w-1.5 h-1.5 rounded-full bg-[#00E5FF] animate-pulse"></span>
            Crafted in Dubai · Performance Lab
          </div>
        </div>

        <div
          data-testid="footer-areas-line"
          className="mt-5 text-[11px] leading-relaxed text-zinc-600 text-center md:text-left"
        >
          Serving:{" "}
          {locations.map((l, i) => (
            <React.Fragment key={l.slug}>
              <Link to={`/locations/${l.slug}`} className="hover:text-zinc-400 transition-colors">
                {l.name}
              </Link>
              {i < locations.length - 1 && " · "}
            </React.Fragment>
          ))}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
